import creditEngineRepository, { CreditEngineRepository } from "@/repositories/creditengine/CreditEngineRepository";

const resource = "/address";
export default {
  getPincodeDetails(pincode) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.get(`${resource}/pincode/${pincode}`);
  }
}